// import { formatAmount } from 'Helper'
import React from 'react'
import { withTranslation } from 'react-i18next'
import useSWR from 'swr'

function  TotRev({t}) {
    
  const { data: stats } = useSWR('dashboard/overview')

    return (
        <div className="grow mb-4">
            <h3 className="text-2xl text-[#05213D] font-semibold">{(stats?.data?.total_revenue)}</h3>
            <h5 className="font-medium text-[#657585] mb-3">{t('misc.total_revenue')}</h5>
        </div>
    )
}

export default  withTranslation()(TotRev)